import { NOTIFICATIONS_GET, NOTIFICATIONS_GET_ALL, NOTIFICATIONS_GET_TOTAL } from './types';

export const getters = {
  [NOTIFICATIONS_GET]: state => {
    return state.notification;
  },
  [NOTIFICATIONS_GET_ALL]: state => {
    return state.notifications;
  },
  [NOTIFICATIONS_GET_TOTAL]: state => {
    return state.notificationsTotal;
  }
};
